import { createProject, updateProject } from 'api/projects';
import { debounceRegional } from 'utils/debounces';

import type { FormType } from '..';

export const projectForm: FormType = {
  createFn: createProject,
  updateFn: updateProject,
  cancelText: 'Cancelar',
  submitText: 'Salvar Projeto',
  disableText: 'Desativar Projeto',
  enableText: 'Ativar Projeto',
  successText: 'Projeto salvo com sucesso!',
  fields: [
    [
      {
        name: 'name',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Ação social',
          label: 'Nome',
        },
      },
      {
        name: 'regional',
        type: 'select',
        required: false,
        props: {
          placeholder: 'Buscar',
          label: 'Regional',
          loadOptions: debounceRegional,
        },
      },
    ],
  ],
};
